import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { Router } from '@angular/router';
import { PayrollService } from 'src/app/shared/services/payrollservices/payroll.service';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { NgApexchartsModule } from "ng-apexcharts";

import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexStroke,
  ApexFill,
  ApexLegend
} from "ng-apexcharts";
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';

export interface lineChartOptions {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  stroke: ApexStroke;
  legend: ApexLegend;
  colors: string[];
}




@Component({
  selector: 'app-payroll-summary',
  standalone: true,
  imports: [CommonModule, NgApexchartsModule, FormsModule],
  templateUrl: './payroll-summary.component.html',
  styleUrl: './payroll-summary.component.css',
})
export class PayrollSummaryComponent implements OnInit {
  public lineChartOptions!: lineChartOptions;
  currentYear: number = new Date().getFullYear();
  months: { month: number; year: number; label: string }[] = [];


  selectedYear: number | null = null;
  years: number[] = [];
  selectedMonth: number | null = null;

  @Output() monthSelected = new EventEmitter<{ year: number, month: number }>();
  newChartOptions: any = {
    chart: {},
    labels: [],
    colors: [],
    plotOptions: {},
    legend: {},
    dataLabels: {},
    stroke: {}
  };

  newChartData: any[] = [];
  departmentsPayroll = [
    { department: 'HR', total: 50000 },
    { department: 'Finance', total: 75000 },
    { department: 'IT', total: 100000 },
    { department: 'Web', total: 50000 },
    { department: 'Mobile', total: 75000 },
    { department: 'BD', total: 100000 }
  ];
  releasedsummaryPercentage: any;
  summaryTotaldeduction: any;
  summaryFinalsettlement: any;
  summaryTotalgross: any;
  summaryPendingTotal: any;
  summaryTotalReleased: any;
  currentMonth: number | '' = '';
  payrollList: any;
  selectedPayroll: any;
  showSkeleton = true; // true while data is loading
  graphSkeleton = true;
  summarySkeleton = true;
  departmentSkeleton = true;
  leave_modification_Date: any;
  showDepartmentChart = false;
  showNoDataImage = false;
  reviewButton = false;
  prseMonth: any;
  prseMonthChar: any;
  prseYear: any;
  total_salary_id: any;
  modalcurrentYear: number = new Date().getFullYear();
  apiMonth: any;
  user: any;
    refresh: any;
  resignationapi: any;
  resign_status: any;
  todayDate: any;
  todayDay: any;
  todayMonth: any;
  formattedDate: any;
  noDataAvailable = false;
  prevYear() {
    this.modalcurrentYear--;
  }

  nextYear() {
    this.modalcurrentYear++;
  }

  selectMonth(monthIndex: number) {
    this.selectedMonth = monthIndex;
    this.monthSelected.emit({ year: this.currentYear, month: monthIndex + 1 });

  }

  selectedMonthYear: string | null = null;
  selecteddepMonthYear: string | null = null;
  modalmonths: string[] = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  public selected_date: any = [];
  public totalSalary: any = [];
  public total_shourtHours: any = [];
  public total_lateCheckin: any = [];
  public total_unpaidLeaves: any = [];
  public total__absents: any = [];
  public total_Advance: any = [];
  public total_Overtime: any = [];
  public total_tax: any = [];
  public loan_amount: any = [];
  public total_otherDeduction: any = [];
  public total_Compensation: any = [];
  public totalDeduction: any = [];
  public totalReleasedSalary: any = [];
  public usersList: any = [];

  public status = '';
  total_absents_count: any = [];
  total_lateCheckin_count: any = [];
  total_shourtHours_count: any = [];
  total_unpaidLeaves_count: any = [];
  selectionMode: any

  hasOverTime = true;
  hasLoan = true;
  hasAdvance = true;
  hasCompensation = true;
  hasTax = true;
  hasTotalDeduction = true;

  constructor(

    public payrollService: PayrollService,
    public router: Router,
    public dashboardService: DashboardService,

  ) {

    this.user_refresh();

    const userInfo = localStorage.getItem('user');


    if (userInfo != null) {
      this.user = JSON.parse(localStorage.getItem('user') || '') || '';
    }


  }
  ngOnInit(): void {
    this.getkeys();



    this.getSummary(this.currentMonth, this.currentYear);
    this.loadDepartmentChart(this.currentMonth, this.currentYear);
    this.getMonthlyList();
    this.getReviewCheck();





  }
  getkeys() {
    this.payrollService.getKeys().then((value) => {

      this.leave_modification_Date = value?.data?.leave_modify_date;

      const leaveModifyDate = new Date(this.leave_modification_Date);
      const cycleStartYear = leaveModifyDate.getFullYear();

      // ✅ Generate correct month order
      this.generateCycleMonths(leaveModifyDate);

      // Populate year dropdown
      this.years = [];
      for (let year = cycleStartYear; year > cycleStartYear - 10; year--) {
        this.years.push(year);
      }

      this.currentYear = cycleStartYear;
      this.loadYearlyChart(this.currentYear);

    }).finally(() => {
      this.summarySkeleton = false;
    });
  }


  getSummary(currentMonth: any, CurrentYear: any) {
    this.summarySkeleton = true
    const month = currentMonth ?? '';
    const year = CurrentYear ?? ''
    this.payrollService.getSummarypayRoll(month, year).then((value) => {
      this.releasedsummaryPercentage = value?.data?.released_percent_change;
      this.summaryTotaldeduction = value?.data?.total_deduction;
      this.summaryFinalsettlement = value?.data?.total_final_settlements;
      this.summaryTotalgross = value?.data?.total_gross_salary;
      this.summaryPendingTotal = value?.data?.total_pending_payrolls;
      this.summaryTotalReleased = value?.data?.total_release_amount;
      this.apiMonth = value?.data?.month;
      this.selectedMonthYear = `${value?.data?.month}-${value?.data?.year}`; // sync select
    }).finally(() => {
      this.summarySkeleton = false
    });

  }

  isPositive(value: string | number): boolean {
    if (typeof value === 'string') {
      // Remove any % or + sign
      value = parseFloat(value.replace('%', '').replace('+', ''));
    }
    return value >= 0;
  }
  loadYearlyChart(year?: number) {
    this.graphSkeleton = true;
    this.noDataAvailable = false;

    this.payrollService.getYearlyPayroll(year).then((res) => {
     
      const labels = res?.data?.labels || [];
      const gross = (res?.data?.gross || []).map((x: any) => Math.round(Number(x)));
      const released = (res?.data?.released || []).map((x: any) => Math.round(Number(x)));
         // Check if data exists
         const isAllZero = gross.every((x:any) => x === 0) && released.every((x:any) => x === 0);
        if (!labels.length || isAllZero) {
          this.noDataAvailable = true;
          return;
        }
      const themeRoot = document.querySelector('.dark-theme') || document.documentElement;
      const textColor = getComputedStyle(themeRoot)
        .getPropertyValue('--text-color').trim();

      this.lineChartOptions = {
        series: [
          { name: "Gross Payroll", data: gross },
          { name: "Released Payroll", data: released }
        ],
        chart: { type: 'bar', height: 350, toolbar: { show: false } },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 2 },
        colors: ['#30A8D4', '#2C3E50'],
        xaxis: { categories: labels, labels: { style: { colors: textColor } } },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          floating: false,
          labels: { colors: textColor } // <-- now read each time
        }
      };
    }).finally(() => this.graphSkeleton = false);
  }


loadDepartmentChart(month?: any, year?: any) {
  this.departmentSkeleton = true;
  this.showDepartmentChart = false;
  this.showNoDataImage = false;

  this.payrollService.getDepartmentSummary(month, year)
    .then(res => {
      debugger; // will now hit here if HTTP is 2xx

      if (!res.success || !res.data || !res.data.length) {
        this.showNoDataImage = true;
        return;
      }

      const departments = res.data;
      this.apiMonth = res?.month;
      this.selecteddepMonthYear = `${res?.month}-${res?.year}`;

      // Check if all totals are zero
      const hasData = departments.some((d:any) => d.total > 0);
      if (!hasData) {
        this.showNoDataImage = true;
        return;
      }

      // Assign colors
      const colorsPalette = ['#129fa2', '#1a68ce', '#86b36a', '#f39c12', '#e74c3c', '#8e44ad', '#e67e22', '#2ecc71', '#3498db', '#9b59b6'];
      const colors = departments.map((d: any, index: number) => colorsPalette[index % colorsPalette.length]);

      // Donut chart options
      this.newChartOptions = {
        chart: { type: 'donut', height: 330, width: '100%' },
        series: departments.map((d:any) => d.total),
        labels: departments.map((d:any) => d.department),
        colors: colors,
        plotOptions: { pie: { donut: { labels: { show: false } } } },
        stroke: { show: false, width: 0 },
        dataLabels: { enabled: false },
        tooltip: { enabled: true, y: { formatter: (val:any) => `${val.toLocaleString()}%` } },
        legend: { show: true, position: 'right', horizontalAlign: 'center', itemMargin: { horizontal: 5, vertical: 5 }, labels: { colors: '#808080' } },
        responsive: [{ breakpoint: 1800, options: { chart: { height: 250 }, legend: { show: false } } }]
      };

      this.showDepartmentChart = true;
      this.showNoDataImage = false;
    })
    .catch(error => {
      console.error('API error:', error);
      this.showNoDataImage = true; // Show placeholder if API fails
    })
    .finally(() => {
      this.departmentSkeleton = false;
    });
}


  onYearChange(year: number) {
    this.currentYear = year;
    this.loadYearlyChart(this.currentYear); // call API to update line chart
  }

  onMonthChange(value: string) {
    if (!value) return;

    // Split the string "1-2026" → [1, 2026]
    const [month, year] = value.split('-').map(Number);

    this.currentMonth = month;
    this.currentYear = year;

    this.getSummary(month, year);
    this.monthSelected.emit({ year: year, month: month });
  }

  ondepMonthChange(month: any) {
    // this.currentMonth = month
    //  this.loadDepartmentChart(this.currentMonth)   
    if (!month) return;

    // Split "month-year" format
    const [monthStr, yearStr] = month.split('-');
    this.currentMonth = parseInt(monthStr, 10);
    this.currentYear = parseInt(yearStr, 10);

    // Call APIs with updated month & year
    // this.getSummary(this.currentMonth,this.currentYear);
    this.loadDepartmentChart(this.currentMonth, this.currentYear);

    // Optional: emit event
    this.monthSelected.emit({ year: this.currentYear, month: this.currentMonth });
  }

  getMonthlyList() {
    this.showSkeleton = true
    this.payrollService.getMonthlyList().then((value) => {
      this.payrollList = value?.data;
      this.checkColumnsVisibility();

    }).finally(() => {
      this.showSkeleton = false;
      // hide spinner after API call finishes
    });

  }

  checkColumnsVisibility() {
    if (!this.payrollList || this.payrollList.length === 0) {
      this.hasOverTime = true;
      this.hasLoan = true;
      this.hasAdvance = true;
      this.hasCompensation = true;
      this.hasTax = true;
      this.hasTotalDeduction = true;
      return;
    }

    this.hasOverTime = this.payrollList.some((p: any) => Number(p.over_time || 0) !== 0);
    this.hasLoan = this.payrollList.some((p: any) => Number(p.loan || 0) !== 0);
    this.hasAdvance = this.payrollList.some((p: any) => Number(p.advance || 0) !== 0);
    this.hasCompensation = this.payrollList.some((p: any) => Number(p.compensation || 0) !== 0);
    this.hasTax = this.payrollList.some((p: any) => Number(p.tax || 0) !== 0);
    this.hasTotalDeduction = this.payrollList.some((p: any) => Number(p.total_deduction || 0) !== 0);
  }


  getStatusClass(status: string) {
    switch (status) {
      case 'processing': return 'process';
      case 'waiting': return 'waiting';
      case 'ready_to_release': return 'release';
      case 'change_required': return 'change-req';
      case 'released': return 'release';
      case 'approved': return 'release';
      case 'canceled': return 'cancel';
      case 'draft': return 'draft';
      case 'submitted': return 'submitted';

      default: return '';
    }
  }

  // Helper to map status to display text
  getStatusText(status: string) {
    switch (status) {
      case 'processing': return 'Processing';
      case 'waiting': return 'Waiting for Approval';
      case 'ready_to_release': return 'Ready to Release';
      case 'change_required': return 'Changes Required';
      case 'released': return 'Released';
      case 'approved': return 'Approved';
      case 'canceled': return 'Canceled';
      case 'draft': return 'Draft';
      default: return status;
    }
  }


  openDeductionModal(payroll: any) {
    this.selectedPayroll = payroll;
  }


  goToAddPayroll() {
    this.router.navigate(['/employee-salary-info']);
  }



  payrolselectMonth(index: any) {
    const monthNumber = index + 1; // 0-based → 1-based

    // Close Bootstrap modal
    ($('#payrollModal') as any).modal('hide');

    const month_int = monthNumber; // example: 1 = Jan, 2 = Feb, etc.

    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const month_char = monthNames[monthNumber - 1];

    this.payrollService.addParollEntery(monthNumber, month_char, this.modalcurrentYear).then((value) => {
      this.payrollList = value?.data;
      this.checkColumnsVisibility();

    }).finally(() => {
      this.showSkeleton = false;
      // hide spinner after API call finishes
    });





    // Navigate with selected month
    this.router.navigate(
      ['/add-new-payroll'],
      {
        queryParams: {
          month: monthNumber,
          year: this.modalcurrentYear
        },
      }
    );
  }
  openPreview(payroll: any) {
    const data = payroll
    const id = payroll?.id
    const [monthName, year] = payroll.month.split(' ');

    const date = new Date(`${monthName} 1, ${year}`);
    const month_int = date.getMonth() + 1; // JS months start from 0

    this.router.navigate(
      ['/add-new-payroll'],
      {
        queryParams: {
          month_name: monthName,
          month: month_int,
          year: year,
          graph: true,
          id: id
        }
      });
  }




  generateCycleMonths(startDate: Date) {
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const now = new Date();
    const monthsArray: { month: number, year: number, label: string }[] = [];

    for (let i = 0; i < 12; i++) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      monthsArray.push({
        month: d.getMonth() + 1,  // 1-based month
        year: d.getFullYear(),
        label: monthNames[d.getMonth()]
      });
    }

    this.months = monthsArray;
  }

  getMonthNumber(monthName: string): number {
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    return monthNames.indexOf(monthName) + 1;
  }

  getReviewCheck() {
    this.payrollService.getReviewCheck()
      .then((value: any) => {
        if (value.success) {
          const data = value?.data;
          this.prseMonthChar = data?.month_char
          this.prseMonth = data?.month_int
          this.prseYear = data?.month_year
          this.total_salary_id = data?.id
          if (data != null && data != undefined) {
            this.reviewButton = true;
          } else {
            this.reviewButton = false;
          }
        } else {
          this.reviewButton = false;
        }
      });
  }

  goPreviewPayroll() {
    this.showSkeleton = true;
    this.getData(this.prseMonthChar, this.prseYear, this.prseMonth);
  }



  getData(month: string, year: number, monthInt: number) {

    this.dashboardService.getAllUserSalariesMonthly(month, year, monthInt).then((value: any) => {
      this.usersList = value.data;

      this.totalSalary = 0
      this.totalDeduction = 0
      this.totalReleasedSalary = 0
      this.total_shourtHours = 0
      this.total_lateCheckin = 0
      this.total_unpaidLeaves = 0
      this.total__absents = 0
      this.total_Advance = 0
      this.total_Overtime = 0
      this.total_tax = 0
      this.loan_amount = 0
      this.total_otherDeduction = 0
      this.total_Compensation = 0
      this.total_shourtHours_count = 0
      this.total_lateCheckin_count = 0
      this.total_unpaidLeaves_count = 0
      this.total_absents_count = 0
      this.status = 'draft';
      this.usersList.forEach((user: any) => {
        if (user.user_salary?.length > 0) {
          this.totalSalary += parseFloat(user.user_salary[0].basic_salary)
          if (user.user_salary[0].total_deduction != null) {
            this.totalDeduction += parseFloat(user.user_salary[0].total_deduction)
          }
          if (user.user_salary[0].released_salary != null) {
            this.totalReleasedSalary += parseFloat(user.user_salary[0].released_salary)
          }

          if (user.user_salary[0].short_hours_amount != null) {
            this.total_shourtHours += parseFloat(user.user_salary[0].short_hours_amount)
          }

          if (user.user_salary[0].short_hours != null) {
            this.total_shourtHours_count += parseFloat(user.user_salary[0].short_hours)
          }

          if (user.user_salary[0].late_check_in_amount != null) {
            this.total_lateCheckin += parseFloat(user.user_salary[0].late_check_in_amount)
          }

          if (user.user_salary[0].late_check_in != null) {
            this.total_lateCheckin_count += parseFloat(user.user_salary[0].late_check_in)
          }

          if (user.user_salary[0].unpaid_leaves_amount != null) {
            this.total_unpaidLeaves += parseFloat(user.user_salary[0].unpaid_leaves_amount)
          }

          if (user.user_salary[0].unpaid_leaves != null) {
            this.total_unpaidLeaves_count += parseFloat(user.user_salary[0].unpaid_leaves)
          }


          if (user.user_salary[0].absents_amount != null) {
            this.total__absents += parseFloat(user.user_salary[0].absents_amount)
          }
          if (user.user_salary[0].absents != null) {
            this.total_absents_count += parseFloat(user.user_salary[0].absents)
          }

          if (user.user_salary[0].advance_payment != null) {
            this.total_Advance += parseFloat(user.user_salary[0].advance_payment)
          }

          if (user.user_salary[0].overtime_amount != null) {
            this.total_Overtime += parseFloat(user.user_salary[0].overtime_amount)
          }

          if (user.user_salary[0].tax != null) {
            this.total_tax += parseFloat(user.user_salary[0].tax)
          }
          // Loan Amount munib
          if (user.user_salary[0].loan_deduction_amount != null) {
            this.loan_amount += parseFloat(user.user_salary[0].loan_deduction_amount)
          }
          if (user.user_salary[0].other_deduction != null) {
            this.total_otherDeduction += parseFloat(user.user_salary[0].other_deduction)
          }

          if (user.user_salary[0].compensation_amount != null) {
            this.total_Compensation += parseFloat(user.user_salary[0].compensation_amount)
          }
          if (user.user_salary[0].status != null) {
            this.status += parseFloat(user.user_salary[0].status)
          }
        }
      });
      this.showSkeleton = false;

      this.router.navigate(
        ['preview-payroll'],   // 👈 your preview route
        {
          state: {
            usersList: this.usersList,
            month_char: this.prseMonthChar,
            month_year: this.prseYear,
            month_int: this.prseMonth,
            check_review: true,
            salary_id: this.total_salary_id,
            totals: {
              totalSalary: this.totalSalary,
              totalDeduction: this.totalDeduction,
              total_Overtime: this.total_Overtime,
              total_Compensation: this.total_Compensation,
              total_tax: this.total_tax
            }
          }
        }
      );
      this.showSkeleton = false;

    });
  }



  getStatusClassForTd(status: string): string {
    switch (status) {
      case 'draft':
        return 'status-pending';
      case 'released':
        return 'status-approved';
      case 'approved':
        return 'status-approved';
      case 'rejected':
        return 'status-rejected';
      case 'change_required':
        return 'status-change_required';
     
      default:
        return '';
    }
  }





  PayrollChecks(type: string): boolean {
    
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.payroll?.data?.values;

    switch (type) {
      case "isAdd":
        return values?.add ?? false;

      case "isApprove":
        return values?.approve ?? false;

      case "isDetail":
        return values?.detail ?? false;

      case "isPreview":
        return values?.preview ?? false;

      case "isRelease":
        return values?.release ?? false;

      case "ismonthly":
        return values?.view_monthly ?? false;

      case "isSumary":
        return values?.view_summary ?? false;

      default:
        return false;
    }
  }



   user_refresh(): void {
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value.data.user;
      this.user = this.refresh;
      const userInfo = this.user;
      this.resignationapi = value.data.resign_status;
      this.resign_status = value.data.resign_status?.status ?? '';
      
      if (userInfo != null) {
        this.user = this.user;
      }

 
    })

  }

}